/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ArgosMenuItem from './ArgosMenuItem';
import React from 'react'
import Select, {SelectProps} from "@mui/material/Select";
import styled from 'styled-components';
import {User} from '../../../pages/CoverageRequirements/Table/Dialogs/constants';


export const userSelectOptions = (userData: User[]) => {
  return(
    userData.sort((a: User, b: User) =>
      a?.lastName.localeCompare(b.lastName) ||
      a?.firstName.localeCompare(b.firstName)
    ).map((user: User) => 
      <ArgosMenuItem
        value={user.id}
      >
        {user?.firstName + " " + user?.lastName}
      </ArgosMenuItem>)
  )
}

const ArgosSelect = (props: SelectProps) => {
  return (
    <StyledSelect
      // variant="outlined"
      variant={props.variant ?? 'standard'}
      {...props}
      // inputProps={{
      //   ...props.inputProps,
      //   style: {
      //     ...props.inputProps?.style,
      //     alignItems: 'center',
      //   }
      //   }}
    >
      {props?.children}
    </StyledSelect>
  )
}

//todo: what to do on overflow
const StyledSelect = styled(Select)({
  minWidth: '200px',
})


export default ArgosSelect
